import React, { useState } from 'react';
import styled, { StylesProps, useStyles } from '../../lib/styles';
import blockWrapperStyles from './BlockWrapper_styles';
import globalStyles from '../../lib/styles/Global_styles';

export interface BlockWrapperProps {
  type: string;
  brand: string;
  classes: string;
  background_colour: string;
  desktop_spacing: string;
  mobile_spacing: string;
}

const BlockWrapper = (
  props: React.PropsWithChildren<BlockWrapperProps> &
    StylesProps<typeof blockWrapperStyles>
) => {
  // console.log('BlockWrapper', {background_colour, desktop_spacing, mobile_spacing})
  const globals = useStyles(globalStyles());

  return (
    <div
      className={`
        ${props.brand} 
        ${props.type} 
        ${props.classes ?? ''} 
        ${props.styles.blockWrap}
        ${globals.acfBlock}`}
    >
      {props.children}
    </div>
  );
};

export default styled(blockWrapperStyles)(BlockWrapper);
